import { Input, Modal, Space, Typography, Upload, Checkbox, Alert } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  createEmployee,
  getEmployeeList,
  updateEmployeeById,
} from "../../store/slices/employeeSlice";

const { Title, Text } = Typography;

const AddEmployeePopup = ({ closePopup, item }) => {
  const formikRef = useRef(null);
  const handleCancel = () => {
    closePopup(false);
  };
  const dispatch = useDispatch();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const initialValues = {
    name: item?.name ?? "",
    position: item?.position ?? "",
    info: item?.info ?? "",
    isBodMember: item?.isBodMember ?? false,
    rank: item?.rank ?? 1,
    showOnHomePage: item?.showOnHomePage ?? false,
    file: item?.filePath ?? null,
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    position: Yup.string().required("Position is required"),
    file: Yup.mixed().required("File is required"),
    info: Yup.string(),
    isBodMember: Yup.boolean(),
    rank: Yup.number(),
    showOnHomePage: Yup.boolean(),
  });

  const onSubmit = (values) => {
    setConfirmLoading(true);

    if (item) {
      const data = {
        name: values.name,
        position: values.position,
        info: values.info,
        isBodMember: values.isBodMember,
        rank: +values.rank,
        showOnHomePage: values.showOnHomePage,
        id: item.id,
      };

      dispatch(
        updateEmployeeById(item.id, data, () => {
          setConfirmLoading(false);
          closePopup(false);
        })
      );
    } else {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("position", values.position);
      formData.append("info", values.info);
      formData.append("isBodMember", values.isBodMember);
      formData.append("rank", +values.rank);
      formData.append("showOnHomePage", values.showOnHomePage);
      formData.append("file", values.file);
      dispatch(
        createEmployee(formData, () => {
          setConfirmLoading(false);
          closePopup(false);
          dispatch(getEmployeeList());
        })
      );
    }
  };

  return (
    <Modal
      title={item ? "Edit Employee" : "Add Employee"}
      open={true}
      confirmLoading={confirmLoading}
      onOk={() => {
        formikRef.current.submitForm();
      }}
      width={768}
      onCancel={handleCancel}
    >
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ errors, touched, handleChange, values, setFieldValue }) => {
          return (
            <Form>
              <Space direction="vertical" style={{ width: "100%" }} size={20}>
                <div>
                  <Title level={5}>Name *</Title>
                  <Input
                    placeholder="Enter employee name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                  />
                  {errors.name && touched.name ? (
                    <Text type="danger">{errors.name}</Text>
                  ) : null}
                </div>
                <div>
                  <Title level={5}>Position *</Title>
                  <Input
                    placeholder="Enter employee position"
                    name="position"
                    value={values.position}
                    onChange={handleChange}
                  />
                  {errors.position && touched.position ? (
                    <Text type="danger">{errors.position}</Text>
                  ) : null}
                </div>
                <div>
                  <Title level={5}>Info</Title>
                  <Input
                    placeholder="Enter additional information"
                    name="info"
                    value={values.info}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <Title level={5}>Bod Member</Title>
                  <Checkbox
                    name="isBodMember"
                    checked={values.isBodMember}
                    onChange={(e) =>
                      setFieldValue("isBodMember", e.target.checked)
                    }
                  >
                    Is Board Member
                  </Checkbox>
                </div>
                <div>
                  <Title level={5}>Show on Home Page</Title>
                  <Checkbox
                    name="showOnHomePage"
                    checked={values.showOnHomePage}
                    onChange={(e) =>
                      setFieldValue("showOnHomePage", e.target.checked)
                    }
                  >
                    Show on Home Page
                  </Checkbox>
                </div>

                <div>
                  <Title level={5}>Rank</Title>
                  <Input
                    placeholder="Enter rank of employee"
                    name="rank"
                    value={values.rank}
                    onChange={handleChange}
                    type="number"
                  />
                </div>

                {!item && (
                  <div>
                    <Title level={5}>Upload File *</Title>
                    <Alert
                      message="Please upload image with size less than 500KB."
                      type="warning"
                      style={{ marginTop: "4px", marginBottom: "16px" }}
                    ></Alert>
                    <Upload.Dragger
                      name="file"
                      action={"/"}
                      multiple={false}
                      fileList={values.file ? [values.file] : []}
                      onChange={(value) =>
                        setFieldValue("file", value.file.originFileObj)
                      }
                      accept=".jpeg,.jpg,.png"
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">
                        Click or drag file to this area to upload
                      </p>
                      <p className="ant-upload-hint">
                        Support for a .jpeg, .jpg, .png
                      </p>
                    </Upload.Dragger>
                    {errors.file && touched.file ? (
                      <Text type="danger">{errors.file}</Text>
                    ) : null}
                  </div>
                )}
              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddEmployeePopup;
